import { useEffect, useRef } from 'react'

// An open question closes on Escape wherever focus is, and only it closes:
// listening in the capture phase runs before, and stops, the page's own
// Escape handling (the mobile details drawer).
export function useCloseOnEscape(onClose: () => void) {
  const close = useRef(onClose)
  close.current = onClose
  useEffect(() => {
    const handle = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return
      event.stopPropagation()
      close.current()
    }
    window.addEventListener('keydown', handle, true)
    return () => window.removeEventListener('keydown', handle, true)
  }, [])
}
